// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ghost{opacity:0.67;background-color:var(--colors-gray-100) !important}.handle{cursor:move}\n", ""]);
// Exports
module.exports = exports;
